import React from 'react';
import { View } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';

interface DialogProps {
  header: React.ReactNode;
  body?: string;
  bodyJsx?: React.ReactNode;
  button?: React.ReactNode;
}

export const Dialog = ({ header, body, bodyJsx, button }: DialogProps) => {
  const { theme } = useStyles();

  return (
    <View
      style={{
        width: '100%',
        borderRadius: 16,
        backgroundColor: theme.colors.background_1,
        borderWidth: 1,
        borderColor: theme.colors.card.default.borderColor,
        gap: 12,
        padding: 16,
      }}
    >
      {header}

      {body ? (
        <Text type="bodyRegular" style={{ color: theme.colors.text.secondary }}>
          {body}
        </Text>
      ) : null}

      {bodyJsx ? bodyJsx : null}

      {button ? button : null}
    </View>
  );
};
